import React, { useEffect, useState } from 'react';
import { useSessionState } from '../hooks/useSessionState';
import RibbonActions from '../components/RibbonActions';
import { getFacturas, registrarPago, updateEstadoFac, enviarEstadoCuenta, getCorreosCliente, enviarEstadoCuentaMasivo, getRecordatorioConfig, setRecordatorioConfig, whatsappEstadoCuenta, whatsappEstadoCuentaMasivo } from '../services/api';
import FiltroPanel from '../components/FiltroPanel';
import { coincide } from '../utils/buscar';
import { hoyColombia } from '../utils/fecha';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');

function aging(fechaVenc) {
  if (!fechaVenc) return null;
  const dias = Math.floor((new Date() - new Date(fechaVenc)) / 86400000);
  return dias;
}

function BadgeAging({ dias }) {
  if (dias === null || dias === undefined) return <span style={{ color:'#64748b', fontSize:12 }}>—</span>;
  if (dias < 0)   return <span style={{ ...sb, background:'#052e16', color:'#86efac' }}>Vence en {-dias}d</span>;
  if (dias === 0) return <span style={{ ...sb, background:'#422006', color:'#fbbf24' }}>Vence hoy</span>;
  if (dias <= 30) return <span style={{ ...sb, background:'#422006', color:'#fbbf24' }}>{dias}d vencida</span>;
  if (dias <= 60) return <span style={{ ...sb, background:'#431407', color:'#fb923c' }}>{dias}d vencida</span>;
  return <span style={{ ...sb, background:'#450a0a', color:'#fca5a5' }}>{dias}d vencida</span>;
}
const sb = { padding:'2px 8px', borderRadius:12, fontSize:11, fontWeight:400, whiteSpace:'nowrap', display:'inline-block' };

const SVG_CARD  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const SVG_ALERT = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const SVG_MAIL  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const SVG_WA    = <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M17.5 14.4c-.3-.15-1.7-.84-1.96-.94-.26-.1-.45-.15-.64.15-.19.29-.74.94-.9 1.13-.17.19-.33.22-.62.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.08-.15-.64-1.55-.88-2.12-.23-.55-.47-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38s1.02 2.76 1.17 2.95c.15.19 2.02 3.08 4.9 4.32.68.29 1.21.47 1.63.6.68.22 1.31.19 1.8.11.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34z"/><path d="M12 2a10 10 0 0 0-8.6 15.06L2 22l5.06-1.33A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3 .79.8-2.92-.2-.31A8.2 8.2 0 1 1 12 20.2z" fill-rule="evenodd"/></svg>;

const IconBtn = ({ svg, title, onClick, color, disabled }) => {
  const [hover, setHover] = React.useState(false);
  return (
    <button title={title} onClick={disabled ? undefined : onClick} disabled={disabled}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{ background: hover && !disabled ? '#334155' : '#1e293b', border:'1px solid #334155', borderRadius:6, width:28, height:28,
               cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? '#475569' : (color || '#e2e8f0'),
               display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'background .15s',
               opacity: disabled ? 0.45 : 1 }}>
      {svg}
    </button>
  );
};

export default function CuentasCobrar() {
  const [facturas, setFacturas] = useState([]);
  const [filtro,   setFiltro]   = useSessionState('cxc_filtro', '');
  const [busq,     setBusq]     = useSessionState('cxc_busq', '');
  const [busqEmp,  setBusqEmp]  = useState('');
  const [modal,    setModal]    = useState(null);
  const [saving,   setSaving]   = useState(false);
  const [formPago, setFormPago] = useState({ monto:'', fecha_pago:'', medio_pago:'transferencia', referencia:'', rfPct:'', ricMil:'', rivaPct:'', montoTocado:false });

  // Retenciones (mismo cálculo que Facturación): retefuente/reteICA sobre el subtotal, reteIVA sobre el IVA.
  const calcRet = (f, fp) => {
    const base = Number(f?.subtotal || 0), ivaBase = Number(f?.iva || 0);
    const rf   = Math.round(base    * Number(fp.rfPct   || 0) / 100);
    const ric  = Math.round(base    * Number(fp.ricMil  || 0) / 1000);
    const riva = Math.round(ivaBase * Number(fp.rivaPct || 0) / 100);
    return { rf, ric, riva, total: rf + ric + riva };
  };
  const onPct = (field, value) => setFormPago(fp => {
    const next = { ...fp, [field]: value };
    if (!fp.montoTocado) { const r = calcRet(modal, next); next.monto = Math.max(0, Number(modal?.saldo || 0) - r.total); }
    return next;
  });
  const calcularEfectivo = () => setFormPago(fp => {
    const r = calcRet(modal, fp);
    return { ...fp, monto: Math.max(0, Number(modal?.saldo || 0) - r.total), montoTocado: false };
  });
  const [recordar, setRecordar] = useState(null); // { clienteId, clienteNombre, email }
  const [enviandoRec, setEnviandoRec] = useState(false);
  const [msgRec, setMsgRec] = useState('');

  // Abre el modal y carga los correos registrados del cliente.
  const abrirRecordar = async (f) => {
    setMsgRec('');
    setRecordar({ clienteId: f.cliente_id, clienteNombre: f.cliente_nombre, correos: [], sel: [], custom: '', mensaje: '', loading: true });
    try {
      const { data } = await getCorreosCliente(f.cliente_id);
      const correos = data.emails || [];
      setRecordar(r => (r && r.clienteId === f.cliente_id ? { ...r, correos, sel: correos.length ? [correos[0].email] : [], loading: false } : r));
    } catch { setRecordar(r => (r ? { ...r, loading: false } : r)); }
  };
  const toggleSel = (email) => setRecordar(r => ({ ...r, sel: r.sel.includes(email) ? r.sel.filter(e => e !== email) : [...r.sel, email] }));
  const destinatarios = () => [...(recordar?.sel || []), ...(recordar?.custom ? [recordar.custom.trim()] : [])].filter(Boolean);

  const enviarRecordatorio = async () => {
    const para = destinatarios();
    if (!para.length) { setMsgRec('❌ Selecciona o escribe al menos un correo'); return; }
    setEnviandoRec(true); setMsgRec('');
    try {
      const { data } = await enviarEstadoCuenta(recordar.clienteId, { para, mensaje: recordar.mensaje || undefined });
      setMsgRec(`✅ ${data.mensaje} (${data.facturas} facturas)`);
      setTimeout(() => { setRecordar(null); setMsgRec(''); }, 2500);
    } catch (e) { setMsgRec('❌ ' + (e.response?.data?.error || 'No se pudo enviar')); }
    finally { setEnviandoRec(false); }
  };

  // Envío masivo (a todos los clientes con cartera)
  const [masivo, setMasivo] = useState(null);   // { soloVencidas, mensaje }
  const [enviandoMas, setEnviandoMas] = useState(false);
  const [msgMas, setMsgMas] = useState('');
  const enviarMasivo = async () => {
    setEnviandoMas(true); setMsgMas('');
    try {
      const { data } = await enviarEstadoCuentaMasivo({ solo_vencidas: masivo.soloVencidas, mensaje: masivo.mensaje || undefined });
      setMsgMas(`✅ Enviados: ${data.enviados} · Sin correo: ${data.sin_correo}${data.errores ? ` · Errores: ${data.errores}` : ''}`);
    } catch (e) { setMsgMas('❌ ' + (e.response?.data?.error || 'No se pudo enviar')); }
    finally { setEnviandoMas(false); }
  };

  // WhatsApp por cliente (abre wa.me con el estado de cuenta pre-cargado)
  const enviarWhatsapp = async (f) => {
    try {
      const { data } = await whatsappEstadoCuenta(f.cliente_id);
      if (data.sin_telefono) {
        alert(`El cliente ${f.cliente_nombre} no tiene un teléfono válido para WhatsApp (${data.telefono || 'vacío'}). Edítalo en el cliente y vuelve a intentar.`);
        return;
      }
      window.open(data.wa_url, '_blank');
    } catch (e) { alert(e.response?.data?.error || 'No se pudo preparar el WhatsApp'); }
  };

  // WhatsApp masivo — lista de clientes con cartera, cada uno con su botón
  const [waMasivo, setWaMasivo] = useState(null); // { soloVencidas, cargando, lista }
  const abrirWaMasivo = async (soloVencidas) => {
    setWaMasivo({ soloVencidas, cargando: true, lista: [] });
    try {
      const { data } = await whatsappEstadoCuentaMasivo(soloVencidas);
      setWaMasivo({ soloVencidas, cargando: false, lista: data.clientes || [] });
    } catch (e) { setWaMasivo({ soloVencidas, cargando: false, lista: [], error: e.response?.data?.error || 'Error' }); }
  };

  // Programación del recordatorio automático
  const [prog, setProg] = useState(null);
  const [savingProg, setSavingProg] = useState(false);
  const abrirProg = async () => {
    try { const { data } = await getRecordatorioConfig(); setProg({ activo: data.activo, dia_semana: data.dia_semana, hora: data.hora, solo_vencidas: data.solo_vencidas }); }
    catch { setProg({ activo: false, dia_semana: 1, hora: 8, solo_vencidas: false }); }
  };
  const guardarProg = async () => {
    setSavingProg(true);
    try { await setRecordatorioConfig(prog); setProg(null); }
    catch (e) { alert(e.response?.data?.error || 'No se pudo guardar'); }
    finally { setSavingProg(false); }
  };

  const load = () => getFacturas().then(r => setFacturas(r.data));
  useEffect(() => { load(); }, []);

  const handlePago = async () => {
    const r = calcRet(modal, formPago);
    const abonoTotal = Number(formPago.monto || 0) + r.total;
    if (abonoTotal <= 0) return alert('Ingrese el monto del cobro');
    if (abonoTotal - Number(modal.saldo || 0) > 1 &&
        !window.confirm(`El abono (${fmt(abonoTotal)}) excede el saldo pendiente (${fmt(modal.saldo)}). ¿Registrar de todos modos?`)) return;
    setSaving(true);
    try {
      await registrarPago(modal.id, { ...formPago, retefuente: r.rf, reteica: r.ric, reteiva: r.riva });
      setModal(null);
      load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  // Cartera real: cualquier factura con saldo pendiente (estado 'aprobada' o 'vencida').
  const pendientes = facturas.filter(f => Number(f.saldo) > 0 && f.estado !== 'anulada' && f.estado !== 'pagada');
  const totalSaldo = pendientes.reduce((s, f) => s + Number(f.saldo), 0);
  const vencidas   = pendientes.filter(f => aging(f.fecha_vencimiento) > 0);
  const empresas = [...new Set(pendientes.map(f => f.cliente_nombre).filter(Boolean))].sort();
  const base = filtro === 'vencida' ? vencidas
    : filtro === 'aldia' ? pendientes.filter(f => (aging(f.fecha_vencimiento) || 0) <= 0)
    : pendientes;
  const vista = busq ? base.filter(f => coincide(busq, f.cliente_nombre, f.nit, f.numero)) : base;

  return (
    <div>
      <div style={s.pageHeader}>
        <div>
          <h1 style={s.h1}>Cuentas por Cobrar</h1>
          <p style={s.sub}>Cartera y recaudo</p>
        </div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[
              { tipo: 'input', label: 'Empresa', value: busq, onChange: setBusq, placeholder: 'Buscar empresa…', width: 240, suggestions: empresas },
              { tipo: 'select', label: 'Ver', value: filtro, onChange: setFiltro, options: [{ value: '', label: 'Todas por cobrar' }, { value: 'vencida', label: 'Vencidas' }, { value: 'aldia', label: 'Al día' }] },
            ]}
            onClear={() => { setBusq(''); setFiltro(''); }}
          />
          <button style={s.btnRecordar} onClick={() => { setMsgMas(''); setMasivo({ soloVencidas: false, mensaje: '' }); }}>📧 Enviar a todos</button>
          <button style={{ ...s.btnRecordar, background:'#0b3d2e', border:'1px solid #25D366', color:'#4ade80' }} onClick={() => abrirWaMasivo(false)}>📱 WhatsApp a todos</button>
          <button style={s.btnRecordar} onClick={abrirProg}>⏰ Programar</button>
        </div></RibbonActions>
      </div>

      {/* KPIs */}
      <div style={s.kpiGrid}>
        <div style={s.kpiCard}>
          <p style={s.kpiLabel}>Total cartera pendiente</p>
          <p style={{ ...s.kpiVal, color:'#f59e0b' }}>{fmt(totalSaldo)}</p>
        </div>
        <div style={s.kpiCard}>
          <p style={s.kpiLabel}>Facturas pendientes</p>
          <p style={{ ...s.kpiVal, color:'#3b82f6' }}>{pendientes.length}</p>
        </div>
        <div style={s.kpiCard}>
          <p style={s.kpiLabel}>Facturas vencidas</p>
          <p style={{ ...s.kpiVal, color:'#ef4444' }}>{vencidas.length}</p>
        </div>
        <div style={s.kpiCard}>
          <p style={s.kpiLabel}>Saldo vencido</p>
          <p style={{ ...s.kpiVal, color:'#ef4444' }}>{fmt(vencidas.reduce((s,f) => s + Number(f.saldo), 0))}</p>
        </div>
      </div>

      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Factura','Cliente','Proyecto','F. Emisión','F. Vencimiento','Total','Saldo','Antigüedad','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {vista.length === 0 && <tr><td colSpan={9} style={s.empty}>{facturas.length ? 'Sin cartera pendiente' : 'Sin registros'}</td></tr>}
            {vista.map(f => (
              <tr key={f.id}>
                <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{f.numero}</td>
                <td style={s.td}>{f.cliente_nombre}</td>
                <td style={s.td}>{f.proyecto_nombre || '—'}</td>
                <td style={s.td}>{f.fecha_emision ? new Date(f.fecha_emision).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}>{f.fecha_vencimiento ? new Date(f.fecha_vencimiento).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}>{fmt(f.total)}</td>
                <td style={{ ...s.td, fontWeight:700, color: Number(f.saldo) > 0 ? '#f59e0b' : '#10b981' }}>{fmt(f.saldo)}</td>
                <td style={s.td}><BadgeAging dias={aging(f.fecha_vencimiento)} /></td>
                <td style={{ ...s.td, whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <IconBtn title="Registrar cobro" svg={SVG_CARD} color="#86efac" onClick={() => {
                      setModal(f);
                      setFormPago({ monto: f.saldo, fecha_pago: hoyColombia(), medio_pago:'transferencia', referencia:'', rfPct:'', ricMil:'', rivaPct:'', montoTocado:false });
                    }} />
                    <IconBtn title={f.estado === 'vencida' ? 'Ya está vencida' : 'Marcar como vencida'} svg={SVG_ALERT} color="#fca5a5" disabled={f.estado === 'vencida'} onClick={() => updateEstadoFac(f.id, 'vencida').then(load)} />
                    <IconBtn title="Enviar recordatorio de estado de cuenta al cliente" svg={SVG_MAIL} color="#93c5fd"
                      onClick={() => abrirRecordar(f)} />
                    <IconBtn title="Enviar estado de cuenta por WhatsApp" svg={SVG_WA} color="#25D366"
                      onClick={() => enviarWhatsapp(f)} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay}>
          <div style={{ ...s.modal }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Registrar cobro — {modal.numero}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.totales}>
                <div style={s.totalRow}><span>Cliente</span><span style={{ color:'#f1f5f9' }}>{modal.cliente_nombre}</span></div>
                <div style={s.totalRow}><span>Total factura</span><span>{fmt(modal.total)}</span></div>
                <div style={{ ...s.totalRow, color:'#f59e0b', fontWeight:700 }}><span>Saldo pendiente</span><span>{fmt(modal.saldo)}</span></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <label style={{ ...s.label, margin:0 }}>Monto recibido *</label>
                    <button type="button" title="Poner el efectivo que cierra la factura (saldo − retenciones)" style={{ background:'transparent', border:'none', color:'#7dd3fc', fontSize:11, cursor:'pointer', padding:0 }} onClick={calcularEfectivo}>↺ Calcular</button>
                  </div>
                  <input style={s.input} type="number" placeholder="Lo consignado por el cliente" value={formPago.monto} onChange={e => setFormPago({...formPago, monto:e.target.value, montoTocado:true})} />
                </div>
                <div style={s.field}><label style={s.label}>Fecha de cobro</label>
                  <input style={s.input} type="date" value={formPago.fecha_pago} onChange={e => setFormPago({...formPago, fecha_pago:e.target.value})} />
                </div>
                <div style={s.field}><label style={s.label}>Medio de pago</label>
                  <select style={s.input} value={formPago.medio_pago} onChange={e => setFormPago({...formPago, medio_pago:e.target.value})}>
                    <option value="transferencia">Transferencia</option>
                    <option value="efectivo">Efectivo</option>
                    <option value="cheque">Cheque</option>
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Referencia / comprobante</label>
                  <input style={s.input} value={formPago.referencia} onChange={e => setFormPago({...formPago, referencia:e.target.value})} />
                </div>
                <div style={s.field}><label style={s.label}>Retefuente %</label>
                  <select style={s.input} value={formPago.rfPct} onChange={e => onPct('rfPct', e.target.value)}>
                    <option value="">No aplica</option>
                    {[0.1,1,1.5,2,2.5,3.5,4,6,10,11].map(v => <option key={v} value={v}>{v}%</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>ReteICA (x mil)</label>
                  <select style={s.input} value={formPago.ricMil} onChange={e => onPct('ricMil', e.target.value)}>
                    <option value="">No aplica</option>
                    {[4,5,6,6.9,7,8,9.66,10,11.04,13.8].map(v => <option key={v} value={v}>{v} x1000</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>ReteIVA %</label>
                  <select style={s.input} value={formPago.rivaPct} onChange={e => onPct('rivaPct', e.target.value)}>
                    <option value="">No aplica</option>
                    {[15,100].map(v => <option key={v} value={v}>{v}%</option>)}
                  </select>
                </div>
              </div>
              {(() => {
                const r = calcRet(modal, formPago);
                const abono = Number(formPago.monto||0) + r.total;
                const dif = Number(modal.saldo||0) - abono;
                return (
                  <div style={{ ...s.totales, marginTop:14 }}>
                    {r.rf > 0  && <div style={s.totalRow}><span>Retefuente ({formPago.rfPct}%)</span><span>{fmt(r.rf)}</span></div>}
                    {r.ric > 0 && <div style={s.totalRow}><span>ReteICA ({formPago.ricMil} x1000)</span><span>{fmt(r.ric)}</span></div>}
                    {r.riva > 0 && <div style={s.totalRow}><span>ReteIVA ({formPago.rivaPct}%)</span><span>{fmt(r.riva)}</span></div>}
                    <div style={s.totalRow}><span>Efectivo recibido</span><span>{fmt(formPago.monto)}</span></div>
                    <div style={s.totalRow}><span>Abono total (efectivo + retenciones)</span><span>{fmt(abono)}</span></div>
                    {formPago.montoTocado ? (
                      <div style={{ ...s.totalRow, fontWeight:700, color:'#f1f5f9' }}>
                        <span>{dif < 0 ? '⚠ Excede el saldo en' : dif > 0 ? 'Saldo tras el pago' : '✓ Cierra exacto'}</span>
                        <span style={{ color: dif > 0 ? '#f59e0b' : dif < 0 ? '#ef4444' : '#10b981' }}>{fmt(Math.abs(dif))}</span>
                      </div>
                    ) : (
                      <div style={s.totalRow}>
                        <span style={{ color:'#94a3b8' }}>Cierre automático — recibirás</span>
                        <span style={{ color:'#10b981', fontWeight:700 }}>{fmt(formPago.monto)}</span>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnCobrar, padding:'10px 20px', fontSize:14, opacity:saving?0.7:1 }} onClick={handlePago} disabled={saving}>{saving ? 'Registrando...' : '✓ Confirmar cobro'}</button>
            </div>
          </div>
        </div>
      )}

      {recordar && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 460 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Recordatorio de estado de cuenta</h2><button style={s.closeBtn} onClick={() => setRecordar(null)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 0 }}>Se enviará a <strong style={{ color: '#f1f5f9' }}>{recordar.clienteNombre}</strong> el detalle de <strong>todas</strong> sus facturas pendientes.</p>
              <div style={s.field}><label style={s.label}>Correos registrados — selecciona a quién enviar</label>
                {recordar.loading ? (
                  <p style={{ color: '#64748b', fontSize: 13, margin: '4px 0' }}>Cargando correos…</p>
                ) : recordar.correos.length ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, margin: '4px 0' }}>
                    {recordar.correos.map((c, i) => (
                      <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, cursor: 'pointer' }}>
                        <input type="checkbox" checked={recordar.sel.includes(c.email)} onChange={() => toggleSel(c.email)} />
                        <span style={{ color: '#f1f5f9' }}>{c.email}</span>
                        <span style={{ color: '#64748b', fontSize: 11 }}>{c.etiqueta}</span>
                      </label>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#f59e0b', fontSize: 13, margin: '4px 0' }}>Este cliente no tiene correos registrados. Escribe uno abajo.</p>
                )}
              </div>
              <div style={{ ...s.field, marginTop: 10 }}><label style={s.label}>Otro correo (opcional)</label>
                <input style={s.input} type="email" placeholder="correo@cliente.com" value={recordar.custom} onChange={e => setRecordar({ ...recordar, custom: e.target.value })} />
              </div>
              <div style={{ ...s.field, marginTop: 12 }}><label style={s.label}>Mensaje (opcional)</label>
                <textarea style={{ ...s.input, minHeight: 70, resize: 'vertical' }} placeholder="Mensaje personalizado…" value={recordar.mensaje} onChange={e => setRecordar({ ...recordar, mensaje: e.target.value })} />
              </div>
              {msgRec && <div style={{ marginTop: 12, fontSize: 13, color: msgRec.startsWith('✅') ? '#6ee7b7' : '#fca5a5' }}>{msgRec}</div>}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setRecordar(null)}>Cancelar</button>
              <button style={{ ...s.btnCobrar, padding: '10px 20px', fontSize: 14, opacity: enviandoRec ? 0.7 : 1 }} onClick={enviarRecordatorio} disabled={enviandoRec}>{enviandoRec ? 'Enviando…' : '📧 Enviar recordatorio'}</button>
            </div>
          </div>
        </div>
      )}

      {masivo && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 460 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Enviar recordatorio a todos</h2><button style={s.closeBtn} onClick={() => setMasivo(null)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 0 }}>Se enviará el estado de cuenta a <strong style={{ color: '#f1f5f9' }}>cada cliente</strong> con cartera y correo registrado (un correo por cliente).</p>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, margin: '4px 0 12px' }}>
                <input type="checkbox" checked={masivo.soloVencidas} onChange={e => setMasivo({ ...masivo, soloVencidas: e.target.checked })} />
                Solo a clientes con facturas <strong>vencidas</strong>
              </label>
              <div style={s.field}><label style={s.label}>Mensaje (opcional)</label>
                <textarea style={{ ...s.input, minHeight: 60, resize: 'vertical' }} placeholder="Mensaje para todos…" value={masivo.mensaje} onChange={e => setMasivo({ ...masivo, mensaje: e.target.value })} />
              </div>
              {msgMas && <div style={{ marginTop: 12, fontSize: 13, color: msgMas.startsWith('✅') ? '#6ee7b7' : '#fca5a5' }}>{msgMas}</div>}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setMasivo(null)}>Cerrar</button>
              <button style={{ ...s.btnCobrar, padding: '10px 20px', fontSize: 14, opacity: enviandoMas ? 0.7 : 1 }} onClick={enviarMasivo} disabled={enviandoMas}>{enviandoMas ? 'Enviando…' : '📧 Enviar a todos'}</button>
            </div>
          </div>
        </div>
      )}

      {waMasivo && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 520 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>WhatsApp a todos los clientes con cartera</h2><button style={s.closeBtn} onClick={() => setWaMasivo(null)}>✕</button></div>
            <div style={{ ...s.modalBody, maxHeight: '60vh', overflowY: 'auto' }}>
              <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 0 }}>Abre el WhatsApp de cada cliente con su estado de cuenta ya escrito. Envía uno por uno (el mensaje sale desde tu propio WhatsApp).</p>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, margin: '4px 0 12px' }}>
                <input type="checkbox" checked={waMasivo.soloVencidas} onChange={e => abrirWaMasivo(e.target.checked)} />
                Solo clientes con facturas <strong>vencidas</strong>
              </label>
              {waMasivo.cargando && <p style={{ color: '#64748b' }}>Cargando…</p>}
              {waMasivo.error && <p style={{ color: '#fca5a5' }}>{waMasivo.error}</p>}
              {!waMasivo.cargando && waMasivo.lista.length === 0 && <p style={{ color: '#64748b' }}>Sin clientes con cartera.</p>}
              {waMasivo.lista.map(c => (
                <div key={c.cliente_id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '8px 0', borderBottom: '1px solid #1e293b' }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ color: '#e2e8f0', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.cliente}</div>
                    <div style={{ color: '#94a3b8', fontSize: 11 }}>{c.n_facturas} fact. · {fmt(c.total)} {c.sin_telefono && <span style={{ color: '#fca5a5' }}>· sin teléfono</span>}</div>
                  </div>
                  {c.sin_telefono
                    ? <span style={{ color: '#64748b', fontSize: 12 }}>—</span>
                    : <a href={c.wa_url} target="_blank" rel="noreferrer" style={{ background: '#0b3d2e', border: '1px solid #25D366', color: '#4ade80', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap' }}>📱 WhatsApp</a>}
                </div>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setWaMasivo(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {prog && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth: 460 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Recordatorio automático</h2><button style={s.closeBtn} onClick={() => setProg(null)}>✕</button></div>
            <div style={s.modalBody}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 14, marginBottom: 14 }}>
                <input type="checkbox" checked={prog.activo} onChange={e => setProg({ ...prog, activo: e.target.checked })} />
                Activar envío automático
              </label>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Día</label>
                  <select style={s.input} value={prog.dia_semana} onChange={e => setProg({ ...prog, dia_semana: Number(e.target.value) })}>
                    {['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'].map((d, i) => <option key={i} value={i + 1}>{d}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Hora</label>
                  <select style={s.input} value={prog.hora} onChange={e => setProg({ ...prog, hora: Number(e.target.value) })}>
                    {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, '0')}:00</option>)}
                  </select>
                </div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, marginTop: 14 }}>
                <input type="checkbox" checked={prog.solo_vencidas} onChange={e => setProg({ ...prog, solo_vencidas: e.target.checked })} />
                Solo a clientes con facturas <strong>vencidas</strong>
              </label>
              <p style={{ color: '#64748b', fontSize: 12, marginTop: 14 }}>Se enviará automáticamente cada semana el día y hora indicados (hora Colombia), a todos los clientes con cartera y correo.</p>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setProg(null)}>Cancelar</button>
              <button style={{ ...s.btnCobrar, padding: '10px 20px', fontSize: 14, opacity: savingProg ? 0.7 : 1 }} onClick={guardarProg} disabled={savingProg}>{savingProg ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  kpiGrid:     { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginBottom:20 },
  kpiCard:     { background:'#1e293b', borderRadius:10, padding:'16px 20px', border:'1px solid #334155' },
  kpiLabel:    { color:'#64748b', fontSize:11, textTransform:'uppercase', letterSpacing:.8, margin:'0 0 6px' },
  kpiVal:      { fontSize:24, fontWeight:700, margin:0 },
  filtros:     { display:'flex', gap:8, marginBottom:16 },
  chip:        { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  chipActive:  { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'4px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569' },
  btnCobrar:   { background:'#166534', color:'#86efac', border:'none', borderRadius:6, padding:'6px 12px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap' },
  btnVencer:   { background:'#450a0a', color:'#fca5a5', border:'none', borderRadius:6, padding:'6px 12px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap', height:30, boxSizing:'border-box' },
  btnRecordar: { background:'#1e3a5f', color:'#93c5fd', border:'1px solid #334155', borderRadius:8, padding:'0 14px', fontSize:13, cursor:'pointer', whiteSpace:'nowrap', height:38, boxSizing:'border-box', display:'inline-flex', alignItems:'center', gap:6 },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:540, display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:16 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  totales:     { background:'#0f172a', borderRadius:10, padding:'14px 18px' },
  totalRow:    { display:'flex', justifyContent:'space-between', color:'#94a3b8', fontSize:13, marginBottom:6 },
};
